import React, { useState, useEffect } from "react";
import axios from "axios";
import "./CreateStaff.css";

const BASE_URL = "/api/admin";

const CreateStaff = () => {
  const [societies, setSocieties] = useState([]);
  const [formData, setFormData] = useState({
    name: "",
    phoneNumber: "",
    description: "",
    societyName: "",
  });
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  useEffect(() => {
    axios
      .get(`${BASE_URL}/names`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((res) => setSocieties(res.data))
      .catch((err) => console.error("Error fetching society names:", err));
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");

    try {
      const response = await axios.post(`${BASE_URL}/staff`, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      });

      setMessage(`✅ Staff created successfully! Staff Code: ${response.data.staffCode}`);
      setMessageType("success");
      setFormData({ name: "", phoneNumber: "", description: "", societyName: "" });
    } catch (error) {
      console.error("Error creating staff:", error);
      setMessage("❌ Failed to create staff. Please try again.");
      setMessageType("error");
    }
  };

  return (
    <div className="staff-form-wrapper">
      <div className="staff-form-box">
        <h3>👷‍♂️ Create Staff</h3>
        <form onSubmit={handleSubmit} className="neon-form">
          <div className="form-field">
            <label>Name</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-field">
            <label>Phone Number</label>
            <input
              type="text"
              name="phoneNumber"
              value={formData.phoneNumber}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-field">
            <label>Description</label>
            <input
              type="text"
              name="description"
              value={formData.description}
              onChange={handleChange}
            />
          </div>

          <div className="form-field">
            <label>Society Name</label>
            <select
              name="societyName"
              value={formData.societyName}
              onChange={handleChange}
              required
            >
              <option value="">-- Select Society --</option>
              {societies.map((society, idx) => (
                <option key={idx} value={society}>
                  {society}
                </option>
              ))}
            </select>
          </div>

          <button type="submit" className="neon-btn">
            Create Staff
          </button>
        </form>

        {message && (
          <div className={`alert ${messageType}`}>{message}</div>
        )}
      </div>
    </div>
  );
};

export default CreateStaff;
